<template>
  <div :class="['ai-mark', props.theme]" v-if="needShow">AI生成</div>
</template>

<script setup lang="ts">
const props = defineProps<{
  theme: 'video' | 'default' | 'mobile';
}>();
const needShow = computed(() => isChinese());
</script>

<style scoped lang="scss">
.ai-mark {
  width: 51px;
  height: 24px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 6px;
  font-size: 12px;
  background: #f2f3f3;
  color: #121926cc;
  border: 1px solid transparent;
  line-height: 1;
  pointer-events: none;

  &.video {
    background: #00000099;
    color: #ffffffcc;
    border: 1px solid #ffffff33;
  }

  &.mobile {
    width: 47px;
    height: 21px;
    border-radius: 4px;
    padding-top: 2px;
    padding-right: 6px;
    padding-bottom: 2px;
    padding-left: 6px;
    gap: 5px;
    background: #ffffff;
  }
}
</style>
